<nav aria-label="..." class="pull-right mr-2 ml-2">
  <ul class="pagination">
    <li class="page-item" [class.disabled]="pageOffset < pageSize">
      <a
        class="page-link"
        (click)="pageOffset < pageSize ? null : moveToFirstPage()"
      >
        <i class="fal fa-fast-backward"></i>
      </a>
    </li>
    <li class="page-item" [class.disabled]="pageOffset < pageSize">
      <a
        class="page-link"
        (click)="pageOffset < pageSize ? null : moveToPreviousPage()"
      >
        <i class="fal fa-step-backward"></i>
      </a>
    </li>
    <li>
      <a
        class="page-link page-counter"
        tooltip="Toplam {{ totalCount | translate }} kayıttan {{
          (totalCount > pageSize ? pageSize : totalCount) | translate
        }} kadar kayıt gösteriliyor. "
      >
        <span
          >{{ "page" | translate }}
          {{ numberCeil((pageOffset + pageSize) / pageSize) | translate }}</span
        >
      </a>
    </li>
    <li
      class="page-item"
      [class.disabled]="totalCount <= pageOffset + pageSize"
    >
      <a
        class="page-link"
        (click)="totalCount <= pageOffset + pageSize ? null : moveToNextPage()"
      >
        <i class="fal fa-step-forward" aria-hidden="true"></i>
      </a>
    </li>
    <li
      class="page-item"
      [class.disabled]="totalCount <= pageOffset + pageSize"
    >
      <a
        class="page-link"
        (click)="totalCount <= pageOffset + pageSize ? null : moveToLastPage()"
      >
        <i class="fal fa-fast-forward" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</nav>
